export default __webpack_public_path__ + "images/S1.7b36766.png";